import Controllers from "../Controllers";
import Locations from "../Locations/Locations";
import Inventory from "../Inventory/Inventory";
import SitesMap from "./SitesMap";
export default [
  {
    name: "Appliances",
    key: "2",
    icon: "",
    Component: Controllers,
  },
  {
    name: "Location",
    key: "1",
    icon: "",
    Component: Locations,
  },
  {
    name: "Site Appliances",
    key: "3",
    icon: "",
    Component: Inventory,
  },
  {
    name: "Map",
    key: "4",
    icon: "",
    Component: SitesMap,
  },
];
